import { ComponentConstructor } from "@mcleod/components";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { LiveDemoLineHeaderPanel } from "./LiveDemoLineHeaderPanel";
import { LiveDemoLinePanel } from "./LiveDemoLinePanel";

export class LiveDemoSectionPanel extends AbstractSectionPanel {
    protected override getLineHeaderPanelClass(): ComponentConstructor {
        return LiveDemoLineHeaderPanel;
    }
    protected override getLinePanelClass(): ComponentConstructor {
        return LiveDemoLinePanel;
    }
}
